import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

const Feedback = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const axiosAPI = useAxios();

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "-";
    const date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleString();
  };

  async function fetchFeedback() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/feedback/get-feedback?page=${page}`
      );
      setFeedback(response?.data?.feedback);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFeedback();
  }, [page]);

  async function changefeedbackStatus(e, feedbackId) {
    const currentStatus = e.target.value;

    console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the Feedback status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/feedback/change-feedback-status/${feedbackId}`,
        { status: currentStatus }
      );

      fetchFeedback();
      window.notifyMessage(
        "Success",
        "Feedback status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing feedback status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change feedback status. Please try again.",
        "danger"
      );
    }
  }

  const openEditModal = (feedbackId, currentStatus) => {
    setIsEditMode(true);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/v1/delete-product/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchFeedback();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  useEffect(() => {
    fetchFeedback();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        {/* Feedback Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Feedbacks ({feedback?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th>Message</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : feedback?.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No feedbacks found.
                          </td>
                        </tr>
                      ) : (
                        feedback &&
                        feedback?.map((feedback) => (
                          <tr key={feedback.id}>
                            <td>{feedback?.name}</td>
                            <td>{feedback?.email}</td>
                            <div>
                              <td>
                                <select
                                  className="form-select"
                                  value={feedback.status}
                                  onChange={(e) =>
                                    changefeedbackStatus(e, feedback?.id)
                                  }
                                >
                                  <option value="1">Approved</option>
                                  <option value="0">Denied</option>
                                </select>
                              </td>
                            </div>
                            <td>{feedback?.message}</td>
                            <td>{formatDateTime(feedback?.created_at)}</td>

                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() =>
                                  openEditModal(feedback.id, feedback.status)
                                }
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(feedback.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
